module.exports = __webpack_public_path__ + "img/icons BFr_1.3b260a27.png";